import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  page: {
    backgroundColor: 'var(--grey-100)',
    p: { xs: '16px', md: '24px' },
    borderRadius: '12px'
  } satisfies SxProps<Theme>,
  intro: {
    mb: '16px',
    maxWidth: '760px'
  } satisfies SxProps<Theme>,
  notice: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: 'var(--blue-500)',
    color: 'var(--white)',
    borderRadius: '8px',
    px: '16px',
    py: '12px',
    mb: '20px'
  } satisfies SxProps<Theme>,
  noticeText: {
    flexGrow: 1,
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  noticeDismiss: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  panel: {
    p: '24px',
    border: '1px solid var(--blue-500)',
    borderRadius: '8px',
    backgroundColor: 'var(--white)',
    flex: 1,
    minWidth: 0
  } satisfies SxProps<Theme>,
  formDescription: {
    mt: '16px',
    mb: '16px'
  } satisfies SxProps<Theme>,
  fieldLabel: {
    display: 'block',
    mb: '8px'
  } satisfies SxProps<Theme>,
  chipBox: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'flex-start',
    gap: '8px',
    minHeight: '150px',
    p: '10px 16px',
    backgroundColor: 'var(--grey-50)',
    border: '1px solid var(--border)',
    borderRadius: '6px',
    cursor: 'text',
    '&:focus-within': {
      borderColor: 'var(--blue-300)',
      boxShadow: '0 0 0 1px var(--blue-300)'
    }
  } satisfies SxProps<Theme>,
  chipInput: {
    flex: 1,
    minWidth: '160px',
    p: 0,
    '& textarea::placeholder': {
      color: 'var(--grey-500)',
      opacity: 1
    }
  } satisfies SxProps<Theme>,
  fieldHelper: {
    mt: '8px',
    color: 'var(--grey-500)'
  } satisfies SxProps<Theme>,
  fieldError: {
    mt: '8px'
  } satisfies SxProps<Theme>,
  sendButton: {
    mt: '8px'
  }
}
